import React from 'react'

const GradientIcon: React.FC<{ size?: number }> = ({ size }) => {
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size ?? 20}
      height={size ?? 20}
    >
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#2D6DF6" />
          <stop offset="100%" stopColor="#964BFF" />
        </linearGradient>
      </defs>
      <path
        fill="url(#gradient)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C8 11 7 10 2 10V8C7 8 8 7 8 2H10C10 7 11 8 16 8V10C11 10 10 11 10 16H8ZM18 18C18 15.5 17.4999 15 15 15V14C17.4999 14 18 13.5074 18 11H19C19 13.5 19.5 14 22 14V15C19.5 15 19 15.5 19 18H18ZM10 20C11.5 20 11.9997 20.5 11.9997 22H12.9998C12.9998 20.5 13.5 20 15 20V19C13.5 19 12.9998 18.5 12.9998 17H11.9997C11.9997 18.5 11.5 19 10 19V20Z"
      ></path>
    </svg>
  )
}

const TextComponent: React.FC<{ text: string }> = ({ text }) => {
  return (
    <span
      className="text-sm font-normal inline-block"
      style={{
        fontFamily: 'Lato',
        background: 'linear-gradient(to right, #2D6DF6, #964BFF)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }}
    >
      {text}
    </span>
  )
}

const AIGradientIconWithText: React.FC<{ text: string; size?: number }> = ({ text, size }) => {
  return (
    <div className="flex items-center gap-2">
      <GradientIcon size={size} />
      <TextComponent text={text} />
    </div>
  )
}

export default AIGradientIconWithText
